import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { TermsAndConditionsManagerCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class TermsAndConditionsManagerCreateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getTermsAndConditionsManagerCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreate),
      switchMap((action) =>
        this.onboardingProductsService.getTermsAndConditionsManagerCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              TermsAndConditionsManagerCreateActions.getTermsAndConditionsManagerCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
